/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Icon } from '@doveit/bricks';
import { configByAgentProfile } from './constants';
import * as styles from './AgentProfileBySalesCard.style';
import { TargetAgentType } from '../../../providers/api/dtos';

export interface AgentProfileBySalesCardProps {
  targetAgentType: TargetAgentType,
}

export const AgentProfileBySalesCard: React.FC<AgentProfileBySalesCardProps> = ({
  targetAgentType,
}) => {
  const {
    title, description, color, icon,
  } = configByAgentProfile[targetAgentType];

  return (
    <div
      css={styles.basic}
      $color={color}
    >
      <div
        css={styles.icon}
        $color={color}
      >
        <Icon size={64} path={icon} />
      </div>
      <div css={styles.info}>
        <div css={styles.title}>
          {title}
        </div>
        <div
          css={styles.description}
          $color={color}
        >
          {description}
        </div>
      </div>
    </div>
  );
};

export default AgentProfileBySalesCard;
